import React, { useEffect } from 'react';

const HeadwayWidget = () => {
    useEffect(() => {
        console.log('Initializing headway widget');
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://cdn.headwayapp.co/widget.js';
        document.head.appendChild(script);
        var config = {
            selector: '.headway-badge',
            account: 'yoEvL7'
        };

        script.onload = () => {
            (window as any).Headway.init(config);
        };
    }, []);

    return (
        <React.Fragment>
            <div>
                <span className='headway-badge' id='headway-badge'></span>
            </div>
        </React.Fragment>
    );
};

export default HeadwayWidget;

const canUseDOM = () => {
    if (typeof window === 'undefined' || !window.document) {
        return false;
    }
    return true;
};

export const closeHeadwayWidget = () => {
    if (canUseDOM() && document.getElementById('HW_frame_cont') != null) {
        (document.getElementById('HW_frame_cont') as HTMLDivElement).className = 'HW_frame_cont HW_bottom';
    }
};
